import styles from './Download.module.css';

function Download(){
    return(
        <section id="download" className={`${styles.download} row ps-xl-5 ps-4`}>
            <img className={`${styles.screenshot2} col-xl-6 mx-xl-5 mx-auto`} src="/img/screenshot/screenshot2.webp" alt="Smartphone com captura de tela"/>
            <div className="col-xl-5 text-start mt-5 pt-xl-5 pt-1">
                <h2 className="fw-bold mb-4">Mude sua rotina o quanto antes!</h2>
                <p className='mb-1'>Cansado de deixar atividades de lado por conta da rotina? Instale o Focus e mude a forma que você lida com seu tempo.</p>
                <a href="https://apkpure.com/p/br.com.codedev_tech.focus" target='_blank'><img className={`${styles.download_button}`} src="/img/appstores/apkpure.webp" alt="APKPure"/></a>
            </div>
        </section>
    )
}

export default Download